import { t } from '@lingui/core/macro';
import { type Point, type PointerEventObject } from 'highcharts';

import { useOfflineTimeline } from '@/api/offlineEvents';
import { type OpportunityType } from '@/api/opportunity';
import { type ChartCallbackFunction } from '@/components/Flare';
import { Panel } from '@/components/panels';
import NonDigitalEventsTimelineChart from '@/features/NonDigitalEventsTimeline/NonDigitalEventsTimelineChart';
import { getOpportunityDateRange } from '@/helper/opportunity-date-util';

type Props = {
  opportunity?: OpportunityType;
  marginLeft: number;
  marginRight: number;
  onHoverChart?: (event: PointerEventObject, point: Point) => void;
  onHoverLeaveChart?: (event: MouseEvent) => void;
  onPostRenderChart?: ChartCallbackFunction;
};

const OpportunityDetailNonDigitalEventsChart = ({
  opportunity,
  marginLeft,
  marginRight,
  onHoverChart,
  onHoverLeaveChart,
  onPostRenderChart,
}: Props) => {
  const { startDate, endDate } = getOpportunityDateRange(opportunity);

  const { offlineTimeline, isLoading, error } = useOfflineTimeline(startDate, endDate, {
    opportunityId: opportunity?.id,
  });

  return (
    <Panel title={t`Non-Digital Events`} verifyC99Tag noPadding>
      <NonDigitalEventsTimelineChart
        data={offlineTimeline}
        isLoading={isLoading || !opportunity}
        error={error}
        marginLeft={marginLeft}
        marginRight={marginRight}
        onHoverChart={onHoverChart}
        onHoverLeaveChart={onHoverLeaveChart}
        onPostRenderChart={onPostRenderChart}
      />
    </Panel>
  );
};

export default OpportunityDetailNonDigitalEventsChart;
